module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAARwAAAAYBAMAAADaPF9xAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURUdwTMvnxMzoxMvnxNHtyM7rxMrmxMrmw6mZ0z4AAAAHdFJOUwDqYLYcGpuBXF60AAAAfklEQVRIx+2XIQ6AMBAENwTwxWAhCDwGi8P2CTh0gXDfp+0nGBLmBSP27vYkqRycvY6bFmWq3RDcPuv0BqFJNoVh6KLOyNE5YnJajk7wqg3EppWkc5Gik8Izk3ROtSSd8Ot8SQcWZdigw9Yg7EjATiisYNDqF6yc0qo76bF5ACT2EGfgp8SQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rectangle-notification-bg.png
// module id = dPQ2
// module chunks = 1